<script>
  import Link from '../../utils/link.html';
  import Menu from '../../components/navigation/step';
  import Archive from '../../components/buttons/trash';
  import Plus from '../../components/buttons/plus';
  import Loader from '../../components/ui/loader.html';
  import { onMount, afterUpdate, getContext } from 'svelte';
  import { gql } from 'apollo-boost';

  import { PROGRAM, programDefaultValue } from '../../graphql/programs';

  import ProgramGeneral from './components/forms/program.general';
  import ProgramPartner from './components/forms/program.partner';
  import ProgramDetails from './components/forms/program.details';
  import ProgramOther from './components/forms/program.other';
  import ProgramCommunications from './components/forms/program.communications';
  import ProgramReview from './components/forms/program.review';

  const client = getContext('apollo');

  export let match = {};
  let loading = true;
  let program = programDefaultValue();
  let error;
  let current = ProgramGeneral;
  let active = match.params.section || 'general';

  function selectStep(id, component) {
    current = component;
    active = id;
  }

  const menu = [
    {
      id: 'general',
      label: 'General',
      click: () => selectStep('general', ProgramGeneral)
    },
    {
      id: 'partner',
      label: 'Partner',
      click: () => selectStep('partner', ProgramPartner)
    },
    {
      id: 'details',
      label: 'Details',
      click: () => selectStep('details', ProgramDetails)
    },
    {
      id: 'other',
      label: 'Other',
      click: () => selectStep('other', ProgramOther)
    },
    {
      id: 'communications',
      label: 'Communications',
      click: () => selectStep('communications', ProgramCommunications)
    },
    { id: 'review', label: 'Review & Submit', click: () => selectStep('review', ProgramReview) }
  ];
</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>Add Program</h1>
  </div>
  <div class="cell small-12 medium-6 text-right">
    <!-- right -->
  </div>
</div>

    <Menu active={active} items={menu} />


<svelte:component this="{current}" bind:value="{program}" />
